module.exports = __webpack_public_path__ + "images/artist_600.1fadb0745cc994599617b28229dbdbbb.png";